import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the MaskPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'mask',
})
export class MaskPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {

    if(args.length > 0 && args[0]["pattern"] != undefined){

    }
    return value.toLowerCase();
  }
}



// WEBPACK FOOTER //
// ./src/pipes/mask/mask.ts